import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const CenteredProgress = ({ colour = null }) => {
    return (
        <Box sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <CircularProgress color={colour || 'inherit'} />
        </Box>
    );
};

export default CenteredProgress;